import axios from "axios";
import { ticketBaseURL } from "../config/api";

export const post_MyCdirAchInfo = async (data: any, userId: number) => {
    const response = await axios({
        url: `${ticketBaseURL}mycdirACHInfo?userId=${userId}`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const delete_MyCdirAchInfo = async (primaryKey: number, userId: string) => {
    const response = await axios({
        url: `${ticketBaseURL}mycdirACHInfo`,
        method: "DELETE",
        params: { id: primaryKey, userId: userId }
    });
    return response.data;
}

export const getMyCdirACHInfoWithTenantIdAndIsActive = (tenantId: string) => {
    return getFetch(`mycdirACHInfo/GetMyCdirACHInfoByTenantIdAndIsActive/${tenantId}`)
}

export const getMyCdirACHInfoWithTenantId = (tenantId: string, page: number, size: number) => {
    return getFetch(`mycdirACHInfo/GetMyCdirACHInfosPagingByTenantId/${tenantId},${page},${size}`)
}

const getFetch = async (url: string, params = {}) => {
    const response = await axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    });
    return response.data;
}